import isSameDayDate from '../date/isSameDayDate';

export default function getDayEvents(day, events) {
  return events && events.length
    ? events.filter(e => isSameDayDate(day, e.start))
    : [];
}
